import { render, staticRenderFns } from "./EditCalendar.vue?vue&type=template&id=3fb97650&scoped=true&"
import script from "./EditCalendar.vue?vue&type=script&lang=ts&"
export * from "./EditCalendar.vue?vue&type=script&lang=ts&"
import style0 from "./EditCalendar.vue?vue&type=style&index=0&id=3fb97650&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fb97650",
  null
  
)

export default component.exports